/**
 * Phase 3 — Warranty provider rate table.
 *
 * Thin vertical wrapper around the shared `<PartnerRateTable />`
 * engine that hardcodes `category="warranty"`. Phase 3 rationale:
 * see /components/tables/InsuranceCarrierTable.jsx.
 */
import React from "react";
import PartnerRateTable from "../PartnerRateTable";
import { WARRANTY_CONFIG } from "../../features/warranty/config";

export default function WarrantyProviderTable({
  sourcePage,
  title,
  subtitle,
  limit = 10,
  onListChange,
  enableFilters = false,
  suppressMethodologyBadge = false,
}) {
  return (
    <div data-testid="warranty-provider-table">
      <PartnerRateTable
        category="warranty"
        sourcePage={sourcePage}
        title={title || WARRANTY_CONFIG.rateTable.headerLabel}
        subtitle={subtitle}
        limit={limit}
        onListChange={onListChange}
        enableFilters={enableFilters}
        suppressMethodologyBadge={suppressMethodologyBadge}
      />
    </div>
  );
}
